import React from 'react';
import '../AIMChat.css';

const BotForm = ({ 
  botData, 
  setBotData, 
  onSubmit, 
  onCancel, 
  title, 
  isGeneratingDesc, 
  isGeneratingPrompt, 
  isGeneratingAvatar,
  onGenerateDesc,
  onGeneratePrompt,
  onGenerateAvatar
}) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  }}>
    <div className="aim-chat-container" style={{ width: '500px', maxWidth: '90vw', maxHeight: '90vh', overflowY: 'auto' }}>
      <div className="aim-chat-header">
        {title}
      </div>
      <div style={{ padding: '15px' }}>
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Name:</label>
          <input
            type="text"
            className="aim-text-input"
            value={botData.name}
            onChange={(e) => setBotData(prev => ({ ...prev, name: e.target.value }))}
            placeholder="Enter bot name..."
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onSubmit();
              }
            }}
          />
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Description:</label>
          <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
            <input
              type="text"
              className="aim-text-input"
              value={botData.description}
              onChange={(e) => setBotData(prev => ({ ...prev, description: e.target.value }))}
              placeholder="Enter bot description..."
              style={{ flex: 1 }}
            />
            <button 
              className="aim-button"
              onClick={() => onGenerateDesc()}
              disabled={isGeneratingDesc || !botData.name.trim()}
              style={{ whiteSpace: 'nowrap' }}
            >
              {isGeneratingDesc ? 'Generating...' : 'Auto Generate'}
            </button>
          </div>
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Avatar Prompt:</label>
          <div style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
            <textarea
              className="aim-text-input"
              value={botData.avatarPrompt}
              onChange={(e) => setBotData(prev => ({ ...prev, avatarPrompt: e.target.value }))}
              placeholder="Describe the avatar you want to generate..."
              rows="2"
              style={{ flex: 1, resize: 'vertical' }}
            />
            <button 
              className="aim-button"
              onClick={() => onGeneratePrompt()}
              disabled={isGeneratingPrompt || !botData.name.trim() || !botData.description.trim()}
              style={{ whiteSpace: 'nowrap' }}
            >
              {isGeneratingPrompt ? 'Generating...' : 'Auto Generate'}
            </button>
          </div>
        </div>

        {botData.avatarPrompt && (
          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Avatar:</label>
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              {botData.avatarUrl ? (
                <img 
                  src={botData.avatarUrl} 
                  alt="Generated avatar"
                  style={{ 
                    width: '64px', 
                    height: '64px', 
                    borderRadius: '50%', 
                    border: '2px solid #ccc'
                  }}
                />
              ) : (
                <div style={{ 
                  width: '64px', 
                  height: '64px', 
                  borderRadius: '50%', 
                  border: '2px solid #ccc',
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  color: '#666'
                }}>
                  No Avatar
                </div>
              )}
              <button 
                className="aim-button"
                onClick={() => onGenerateAvatar()}
                disabled={isGeneratingAvatar || !botData.avatarPrompt.trim()}
              >
                {isGeneratingAvatar ? 'Generating...' : 'Generate Avatar'}
              </button>
            </div>
          </div>
        )}

        <div className="aim-button-group">
          <button className="aim-button" onClick={onSubmit}>
            {title.includes('Edit') ? 'Save Changes' : 'Create Bot'}
          </button>
          <button className="aim-button" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  </div>
);

export default BotForm; 